import Axios, {AxiosResponse} from "axios";
import {ViewEnum} from "../models/view";
import RootApi from "./root-api";

export default class SysApi extends RootApi {
    private readonly apiEndpoint: string = `${this.ApiRoot}/sys`;

    public async getOptions(): Promise<AxiosResponse> {
        return await Axios.get(`${this.apiEndpoint}/options`);
    }

    public async getTextsByView(viewName: ViewEnum): Promise<AxiosResponse> {
        return await Axios.get(`${this.apiEndpoint}/${viewName}/texts`);
    }
}



// WEBPACK FOOTER //
// ./src/api/sys-api.ts